import React from "react";

const ContactCentreRemediation = () => {
  return (
    <div className="modal-content-body">
      <div className="modal-section">
        <div className="flex-content">
          <div>
            <h3>Use Case</h3>
          </div>
          <div>
            <p>
              Ongoing optimisation, innovation, and managed support for existing
              Amazon Connect environments - maximising ROI, client retention,
              and feature adoption.
            </p>
          </div>
        </div>

        <div className="flex-content">
          <div>
            <h3>Solution</h3>
          </div>
          <div>
            <a
              href="https://signin.aws.amazon.com/oauth?client_id=arn%3Aaws%3Aiam%3A%3A015428540659%3Auser%2Fawsmp-contessa&redirect_uri=https%3A%2F%2Faws.amazon.com%2Fmarketplace%2Fpp%2Fprodview-vqus34fcpmqks%3FapplicationId%3DAWSMPContessa%26ref_%3Dbeagle%26sr%3D0-1%26isauthcode%3Dtrue&response_type=code"
              target="_blank"
              rel="noopener noreferrer">
              Amazon Connect Accelerated
            </a>
          </div>
        </div>

        <div className="flex-content">
          <div>
            <h3>Target Segment</h3>
          </div>
          <div>
            <ul>
              <li>
                Mid-sized to enterprise customers already using AWS Connect
              </li>
              <li>
                Multi-site/customer-centric businesses seeking continuous
                improvement
              </li>
              <li>
                Organisations with stagnating, under-utilised, or high-cost
                contact centre operations
              </li>
            </ul>
          </div>
        </div>

        <div className="flex-content">
          <div>
            <h3>Target Personas</h3>
          </div>
          <div>
            <p>
              Head of CX, IT Manager, Contact Centre Director, COO, Operations
              Manager
            </p>
          </div>
        </div>
      </div>

      {/* Opportunity & Qualification */}
      <div className="modal-section">
        <h2 className="modal-section-title">Opportunity and Qualification</h2>
        <div className="modal-section-grid">
          <div className="modal-column">
            <h3 className="modal-subtitle">
              What is the customer trying to accomplish?
            </h3>
            <ul>
              <li>Increase ROI and reduce operational overhead</li>
              <li>Accelerate adoption of AI, automation, and analytics</li>
              <li>Continuously enhance customer and agent experience</li>
              <li>Stay up-to-date with AWS innovation with minimal lift</li>
              <li>
                Proactively address issues, cost leaks, or compliance gaps
              </li>
            </ul>
          </div>

          <div className="modal-column">
            <h3 className="modal-subtitle">Key Words/ Questions</h3>
            <ul>
              <li>Lacking new feature adoption or stuck on legacy workflows</li>
              <li>Want to improve/support AI, reporting, or automation</li>
              <li>
                Unsure if the platform is optimised for cost, compliance, or CX
              </li>
              <li>Seeking managed or advisory support for contact centre</li>
            </ul>
          </div>

          <div className="modal-column">
            <h3 className="modal-subtitle">Pain Point/ Challenge</h3>
            <ul>
              <li>Underutilised or poorly performing Amazon Connect</li>
              <li>High operational costs, manual QA and reporting</li>
              <li>Missed innovation cycles, lagging AI or automation</li>
              <li>
                Limited internal Amazon Connect skills or time for improvement
                projects
              </li>
            </ul>
          </div>

          <div className="modal-column">
            <h3 className="modal-subtitle">Qualifying Questions</h3>
            <ul>
              <li>
                Are you fully leveraging the latest AWS Connect features and AI
                capabilities?
              </li>
              <li>
                Would you value regular health checks, innovation reviews, and
                cost optimisation?
              </li>
              <li>Has performance plateaued since your initial launch?</li>
              <li>
                Would ongoing advisory and managed support free your team for
                higher-value work?
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Proposed Solution */}
      <div className="modal-section">
        <h2 className="modal-section-title">Proposed Solution / Value</h2>
        <div className="flex-content-half">
          <div>
            <h3>Solution Description</h3>
            <ul style={{marginTop: "10px"}}>
              <li>
                Continuous Amazon Connect improvement via regular consult
                reviews, audits, and innovation sessions. Let us do the grunt
                work.
              </li>
              <li>
                Embeds advanced analytics, AI/GenAI, knowledge management, and
                workflow automation
              </li>
              <li>
                24/7 monitoring, incident response, compliance, and cost
                optimisation
              </li>
              <li>
                Expert support for roadmap planning and business case delivery
              </li>
            </ul>
          </div>
          <div>
            <h3>Solution Benefits to AWS Customers</h3>
            <ul style={{marginTop: "10px"}}>
              <li>40%+ CX efficiency gains, measurable and ongoing</li>
              <li>Always-current AWS features unleash new value</li>
              <li>Reduced risk, lower TCO, and proactive compliance</li>
              <li>Data-driven improvement for stronger retention and NPS</li>
            </ul>
          </div>
        </div>

        {/* hello */}
        <h2 className="modal-section-title" style={{marginTop: "30px"}}>
          Objection Handling
        </h2>
        <div className="flex-content-half">
          <div>
            <p>
              No Resources for Ongoing Projects: Through our specialist
              partners, they'll manage all uplift; your team is freed up for
              core priorities.
            </p>

            <p>
              We Already Have Managed Support: iCXeed delivers AWS-native,
              innovation-focused support - not just “incident support or
              break/fix.”​
            </p>
            <p>
              Cost Savings Doubt - With AWS pay-as-you-go pricing and automation
              features, most clients see substantial cost reductions compared to
              legacy tech from day one.
            </p>
            <p>
              Platform Is Good Enough: Let's benchmark your Connect ROI and
              missed value - results often surprise.
            </p>
            <p>
              GenAI Isn't Ready for Us: We deliver only mature, proven AI
              enablement - at your pace.
            </p>
            <p>
              Compliance or Costs a Concern: Enjoy ongoing audits, optimisation,
              and incident readiness built-in.
            </p>
          </div>
        </div>
      </div>

      {/* FootNote */}
      <div className="modal-section" style={{border: 0}}>
        <div className="flex-content-half">
          <div className="flex-content-half">
            <div>
              <p>Resource Links</p>
            </div>
            <div>
              <p>Insert Link</p>
            </div>
          </div>
          <div className="flex-content-half">
            <div>
              <p>Average Opportunity ARR:</p>
            </div>
            <div>
              <p>
                Insert the expected Annualized AWS Consumption Revenue Value
              </p>
            </div>
          </div>
        </div>
        <div className="flex-content-half">
          <div className="flex-content-half">
            <div>
              <p>Case Study Links</p>
            </div>
            <div>
              <p>Insert Link</p>
            </div>
          </div>
          <div className="flex-content-half">
            <div>
              <p>Primary Partner Contact:</p>
            </div>
            <div>
              <p>
                Ryan Rayner, Co-Founder | ryan.rayner@icxeed.ai +61 438 286 198
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactCentreRemediation;
